/**
 * WordPress dependencies.
 */
import { Fragment } from '@wordpress/element';
import { Panel, PanelBody } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { applyFilters, addFilter } from '@wordpress/hooks';

/**
 * Inner dependencies.
 */
import SettingsToolbarArea from '../components/SettingsToolbarArea';
import ActivePostTypes from '../components/ActivePostTypes';
import '../../../extensions/store/settings';

addFilter( 'gutenify-admin-settings-panel', 'gutenify/admin/settings/panel/general', ( content, props ) => (
	[ ...content, <Fragment key="gutenify-admin-settings-panel-general">
		<PanelBody title={ __( 'Gutenberg editor' ) } initialOpen={ 'general' === props.activePanel }>
			<div>{ __( 'Post Type' ) }<p className="description">{ __( 'Choose post types to activate Gutenburg.' ) }</p></div>
			<ActivePostTypes { ...props } />
		</PanelBody>
	</Fragment> ]
) );

const GeneralTab = ( props ) => {
	return <>
		<Fragment key="gutenify-admin-settings-panel">
			<SettingsToolbarArea { ...props } />
			<Panel header={ __( '' ) }>
				{ applyFilters( 'gutenify-admin-settings-panel', [], props ) }
			</Panel>
			<SettingsToolbarArea { ...props } />
		</Fragment>
	</>;
};

export default GeneralTab;
